/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Extendedsearch_Noitems2Inputs */

const id_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada item ditemukan.`)
};

const ms_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada item ditemui.`)
};

const da_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen items fundet.`)
};

const de_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Items gefunden.`)
};

const en_us2_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found.`)
};

const es_es2_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron items.`)
};

const es_mx2_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron ítems.`)
};

const fil_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang item.`)
};

const fr_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun item trouvé.`)
};

const it_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun articolo trovato.`)
};

const hu_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található elem.`)
};

const nl_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen items gevonden.`)
};

const no_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen elementer funnet.`)
};

const pl_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono elementów.`)
};

const pt_br2_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found.`)
};

const pt_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum item encontrado.`)
};

const ro_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit elemente.`)
};

const fi_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteita ei löytynyt.`)
};

const sv_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga objekt hittades.`)
};

const vi_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy mục.`)
};

const tr_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe bulunamadı.`)
};

const cs_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné položky.`)
};

const bg_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени обекти.`)
};

const ru_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объекты не найдены.`)
};

const uk_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементів не знайдено.`)
};

const ar_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على عناصر.`)
};

const hi_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई आइटम नहीं मिला।`)
};

const th_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรายการ`)
};

const ja_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムが見つかりません。`)
};

const zh_cn2_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found.`)
};

const zh_hant1_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found.`)
};

const ko_components_extendedsearch_noitems2 = /** @type {(inputs: Components_Extendedsearch_Noitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found.`)
};

/**
* | output |
* | --- |
* | "No items found." |
*
* @param {Components_Extendedsearch_Noitems2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_extendedsearch_noitems2 = /** @type {((inputs?: Components_Extendedsearch_Noitems2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Extendedsearch_Noitems2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_extendedsearch_noitems2(inputs)
	if (locale === "ms") return ms_components_extendedsearch_noitems2(inputs)
	if (locale === "da") return da_components_extendedsearch_noitems2(inputs)
	if (locale === "de") return de_components_extendedsearch_noitems2(inputs)
	if (locale === "en-US") return en_us2_components_extendedsearch_noitems2(inputs)
	if (locale === "es-ES") return es_es2_components_extendedsearch_noitems2(inputs)
	if (locale === "es-MX") return es_mx2_components_extendedsearch_noitems2(inputs)
	if (locale === "fil") return fil_components_extendedsearch_noitems2(inputs)
	if (locale === "fr") return fr_components_extendedsearch_noitems2(inputs)
	if (locale === "it") return it_components_extendedsearch_noitems2(inputs)
	if (locale === "hu") return hu_components_extendedsearch_noitems2(inputs)
	if (locale === "nl") return nl_components_extendedsearch_noitems2(inputs)
	if (locale === "no") return no_components_extendedsearch_noitems2(inputs)
	if (locale === "pl") return pl_components_extendedsearch_noitems2(inputs)
	if (locale === "pt-BR") return pt_br2_components_extendedsearch_noitems2(inputs)
	if (locale === "pt") return pt_components_extendedsearch_noitems2(inputs)
	if (locale === "ro") return ro_components_extendedsearch_noitems2(inputs)
	if (locale === "fi") return fi_components_extendedsearch_noitems2(inputs)
	if (locale === "sv") return sv_components_extendedsearch_noitems2(inputs)
	if (locale === "vi") return vi_components_extendedsearch_noitems2(inputs)
	if (locale === "tr") return tr_components_extendedsearch_noitems2(inputs)
	if (locale === "cs") return cs_components_extendedsearch_noitems2(inputs)
	if (locale === "bg") return bg_components_extendedsearch_noitems2(inputs)
	if (locale === "ru") return ru_components_extendedsearch_noitems2(inputs)
	if (locale === "uk") return uk_components_extendedsearch_noitems2(inputs)
	if (locale === "ar") return ar_components_extendedsearch_noitems2(inputs)
	if (locale === "hi") return hi_components_extendedsearch_noitems2(inputs)
	if (locale === "th") return th_components_extendedsearch_noitems2(inputs)
	if (locale === "ja") return ja_components_extendedsearch_noitems2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_extendedsearch_noitems2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_extendedsearch_noitems2(inputs)
	return ko_components_extendedsearch_noitems2(inputs)
});
export { components_extendedsearch_noitems2 as "components.extendedSearch.noItems" }